module.exports = __webpack_public_path__ + "img/programme4.652b233c.png";